const cards = [
  {
    title: '本周口碑第一：这部冷门佳作别错过',
    tag: '编辑推荐',
    desc: '一部被严重低估的独立电影，豆瓣评分 8.7，叙事手法惊艳，情感细腻动人。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20cinematic%20scene%20of%20a%20quiet%20indie%20film%20aesthetic%2C%20warm%20golden%20hour%20light%20through%20window%2C%20soft%20shadows%2C%20artistic%20composition%2C%20film%20grain%20texture%2C%20rich%20amber%20tones%2C%20contemplative%20mood%2C%20no%20text%2C%20cinematic%20still&width=600&height=400&seq=card-1&orientation=landscape',
  },
  {
    title: '暑期追剧指南：七月必看剧集清单',
    tag: '追剧指南',
    desc: '从古装到现代，从悬疑到治愈，这份七月追剧清单请收好。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20evening%20living%20room%20with%20TV%20screen%20glowing%2C%20soft%20ambient%20golden%20lighting%2C%20comfortable%20atmosphere%2C%20cinematic%20home%20theater%20vibe%2C%20rich%20amber%20and%20brown%20tones%2C%20no%20text%2C%20elegant%20interior&width=600&height=400&seq=card-2&orientation=landscape',
  },
  {
    title: '那些让你刷三遍都不过瘾的神作',
    tag: '深度影评',
    desc: '有些电影值得反复品味，每次观看都能发现新的细节与感动。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20vintage%20movie%20tickets%20on%20warm%20wooden%20table%2C%20soft%20golden%20spotlight%2C%20nostalgic%20theater%20atmosphere%2C%20rich%20sepia%20tones%2C%20elegant%20composition%2C%20no%20text%2C%20artistic%20still%20life&width=600&height=400&seq=card-3&orientation=landscape',
  },
  {
    title: '从零开始的纪录片入门指南',
    tag: '观影指南',
    desc: '纪录片不只是"科普"，它可以是惊悚、浪漫、甚至爆笑的。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20nature%20documentary%20scene%20with%20warm%20sunset%20light%2C%20sweeping%20landscape%2C%20cinematic%20wide%20shot%2C%20rich%20golden%20and%20earthy%20tones%2C%20epic%20scale%2C%20film%20aesthetic%2C%20no%20text%2C%20breathtaking%20composition&width=600&height=400&seq=card-4&orientation=landscape',
  },
  {
    title: '动画电影的成人世界：不止给孩子看',
    tag: '文化观察',
    desc: '当代动画电影早已突破年龄界限，探讨的议题深度不输真人电影。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20animated%20film%20concept%20art%20style%20scene%2C%20warm%20magical%20glowing%20atmosphere%2C%20dreamy%20fantasy%20lighting%2C%20rich%20amber%20and%20gold%20tones%2C%20cinematic%20aesthetic%2C%20no%20text%2C%20enchanting%20composition&width=600&height=400&seq=card-5&orientation=landscape',
  },
  {
    title: '华语电影年度期待：下半年还有哪些惊喜',
    tag: '行业动态',
    desc: '盘点 2026 下半年最值得期待的华语电影，多部重磅作品即将登场。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20set%20with%20warm%20professional%20lighting%20equipment%2C%20director%20monitor%20glowing%2C%20movie%20production%20atmosphere%2C%20rich%20amber%20and%20dark%20tones%2C%20dramatic%20backlight%2C%20no%20text%2C%20elegant%20composition&width=600&height=400&seq=card-6&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            编辑精选的深度内容，发现更多影视世界的精彩
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 2).map((card, idx) => (
            <article
              key={idx}
              className="lg:col-span-2 bg-background-100 rounded-lg overflow-hidden group cursor-pointer flex flex-col md:flex-row"
            >
              <div className="md:w-[45%] aspect-[3/2] md:aspect-auto overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="md:w-[55%] p-5 md:p-6 flex flex-col justify-center">
                <span className="text-xs font-medium text-accent-500 bg-accent-100/70 self-start px-2.5 py-1 rounded-full mb-2">
                  {card.tag}
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 leading-snug">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </article>
          ))}

          {cards.slice(2).map((card, idx) => (
            <article
              key={idx + 2}
              className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs font-medium text-accent-500 bg-accent-100/70 self-start px-2.5 py-1 rounded-full mb-2 inline-block">
                  {card.tag}
                </span>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2 leading-snug">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}